export default "__VITE_ASSET__DJPXXtnT__"